import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, ChevronRight } from 'lucide-react';
import { ordersAPI } from '../utils/api';

function statusColor(s) {
  const map = { pending: 'badge-pending', confirmed: 'badge-confirmed', processing: 'badge-confirmed', shipped: 'badge-confirmed', delivered: 'badge-delivered', cancelled: 'badge-cancelled' };
  return map[s] || 'badge-pending';
}

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    ordersAPI.getMy().then(res => setOrders(res.data.orders)).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <div className="container" style={{ padding: '40px 24px' }}>
      <h1 style={{ fontFamily: 'Syne', fontSize: 36, fontWeight: 800, marginBottom: 32 }}>My Orders</h1>
      {orders.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 80 }}>
          <Package size={64} color="var(--text-muted)" style={{ marginBottom: 24 }} />
          <h2 style={{ fontFamily: 'Syne', fontSize: 24, marginBottom: 12 }}>No orders yet</h2>
          <button className="btn btn-primary" onClick={() => navigate('/products')}>Start Shopping</button>
        </div>
      ) : orders.map(order => (
        <div key={order._id} onClick={() => navigate(`/orders/${order._id}`)} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, padding: 24, marginBottom: 12, cursor: 'pointer', transition: 'all 0.2s', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.transform = 'none'; }}>
          <div className="order-card-row" style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
            <div style={{ width: 56, height: 56, background: 'var(--bg-secondary)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Package size={24} color="var(--accent)" />
            </div>
            <div>
              <div style={{ fontFamily: 'Syne', fontWeight: 700, marginBottom: 4 }}>#{order.orderNumber}</div>
              <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>{order.items.length} items · {new Date(order.createdAt).toLocaleDateString()}</div>
            </div>
          </div>
          <div className="order-card-actions" style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
            <span className={`badge badge-status ${statusColor(order.status)}`}>{order.status.charAt(0).toUpperCase() + order.status.slice(1)}</span>
            <div style={{ fontFamily: 'Syne', fontWeight: 800, fontSize: 18, color: 'var(--gold)' }}>${order.totalPrice.toFixed(2)}</div>
            <ChevronRight size={18} color="var(--text-muted)" />
          </div>
        </div>
      ))}
    </div>
  );
}
